import {
  DetailType,
  HandballThrowSavedAttribute,
} from '@collector/sportsapi-client-legacy'

import { DetailConfiguration } from '../../../../composables/useSportOptions'
import { GroupName } from '../../consts'

export const groups: Map<
  GroupName,
  DetailConfiguration<HandballThrowSavedAttribute>
> = new Map([
  [
    GroupName.Style,
    {
      type: DetailType.Button,
      name: GroupName.Style,
      important: true,
      attributes: [
        HandballThrowSavedAttribute.Air,
        HandballThrowSavedAttribute.Ground,
      ],
      cols: 2,
      multiple: false,
    },
  ],
  [
    GroupName.Type,
    {
      type: DetailType.Button,
      name: GroupName.Type,
      important: false,
      attributes: [
        HandballThrowSavedAttribute.FastAttack,
        HandballThrowSavedAttribute.AfterTurnover,
        {
          attributeId: HandballThrowSavedAttribute.Pivot,
          isActive: (attributes: readonly HandballThrowSavedAttribute[]) => {
            return !attributes.some((attribute) =>
              [
                HandballThrowSavedAttribute.LeftWing,
                HandballThrowSavedAttribute.RightWing,
                HandballThrowSavedAttribute.NineMeter,
              ].includes(attribute),
            )
          },
        },
        {
          attributeId: HandballThrowSavedAttribute.Breakthrough,
          isActive: (attributes: readonly HandballThrowSavedAttribute[]) => {
            return !attributes.some((attribute) =>
              [
                HandballThrowSavedAttribute.LeftWing,
                HandballThrowSavedAttribute.RightWing,
                HandballThrowSavedAttribute.NineMeter,
              ].includes(attribute),
            )
          },
        },
        HandballThrowSavedAttribute.DoubleSave,
      ],
      cols: 3,
      multiple: true,
    },
  ],
])
